import student_dashboard from './screens/student_dashboard'
import student_dashboard_v2 from './screens/student_dashboard_v2'


/**
 * @INFO Pasos de las diferentes screens
 * * IMPORTANTE: el nombre de la propiedad debe tener el mismo nombre que el type
 */
const stepsData = {
  student_dashbord: student_dashboard,
  student_dashboard_v2: student_dashboard_v2,
}

export default stepsData
